import configuration from '../envConfig';

declare var cordova: any;

const requestLocationPermission = (): Promise<boolean> => {
    return new Promise((resolve) => {
        if (!configuration.isCordova || !cordova.plugins?.diagnostic) {
            resolve(true);
            return;
        }

        const diagnostic = cordova.plugins.diagnostic;
        
        diagnostic.isLocationAuthorized(
            (authorized: boolean) => {
                if (authorized) {
                    resolve(true);
                } else {
                    diagnostic.requestLocationAuthorization(
                        () => {
                            diagnostic.isLocationAuthorized(
                                (auth: boolean) => {
                                    resolve(auth);
                                },
                                (error: any) => {
                                    console.error('[LOCATION] Erro ao verificar após solicitar:', error);
                                    resolve(false);
                                }
                            );
                        },
                        (error: any) => {
                            console.error('[LOCATION] Erro ao solicitar permissão:', error);
                            resolve(false);
                        }
                    );
                }
            },
            (error: any) => {
                console.error('[LOCATION] Erro ao verificar autorização:', error);
                resolve(false);
            }
        );
    });
};

export const getLocation = async function(onSuccess, onError){
    if(configuration.isCordova) {
        await requestLocationPermission();
    }

    if (navigator.geolocation) {
        var timeoutVal = 10 * 1000;
        navigator.geolocation.getCurrentPosition(onSuccess, onError, {
            enableHighAccuracy: true,
            timeout: timeoutVal,
            maximumAge: 0
        });
    } else {
        alert('Seu Navegador não suporta Mapas e/ou Geolocalização');
    }
};

